import {createContext, useState} from 'react';
import Team from './components/Team';
import Offering from './components/Offering';
import Customer from './components/Customer';
import style from './style.module.scss';
import classNames from 'classnames';
import TeamIcon from 'components/Sidebar/MenuIcon/IconTeams';
import OfferingIcon from 'components/Sidebar/MenuIcon/IconPackage';
import CustomerIcon from 'components/Sidebar/MenuIcon/IconUsers';
import Typography from 'components/Typography';
import useCompanyConfig from 'hooks/useCompanyConfig';
import api from 'api';
import useAuth from 'hooks/useAuth';
import {useHistory} from 'react-router-dom';
import {useMutation} from 'react-query';

export const OnboardingContext = createContext({
  data: {
    employee: {},
    team: {},
    offering: {},
    customer: {},
    step: 0,
  },
  setData: (data: any) => {},
});

const onboardUser = async () => {
  return await api.post('/users/onboard/', {
    is_onboarded: true,
  });
};

function Onboarding() {
  const [data, setData] = useState({
    employee: {},
    team: {},
    offering: {},
    customer: {},
    step: 1,
  });
  const {currentUser, setUser} = useAuth();
  const history = useHistory();
  const {hasFeature} = useCompanyConfig();
  const {mutateAsync: markAsOnboarded, isLoading} = useMutation({
    mutationFn: onboardUser,
    onSuccess: () => {
      if (currentUser) setUser({...currentUser, is_onboarded: true});
      history.replace('/orders');
    },
  });
  const steps = [
    {
      title: 'Customer',
      component: <CustomerIcon color={'#4286f4'} />,
    },
    {
      title: hasFeature('hasServiceOnOrderCreation')
        ? 'Service/Product'
        : 'Product',
      component: <OfferingIcon color={'#4286f4'} />,
    },
    {
      title: 'Mobile Worker',
      component: <TeamIcon color={'#4286f4'} />,
    },
  ];

  return (
    <OnboardingContext.Provider value={{data, setData}}>
      <Typography style={{marginLeft: 30, fontWeight: '500'}} variant="h1">
        Onboarding
      </Typography>
      <div className={style.steps}>
        {steps.map((item, index) => {
          return (
            <div className={style.stepperItem} key={index}>
              <div className={style.stepperContainer}>
                <div
                  className={classNames(style.stepper, {
                    [style.active]: index < data.step,
                  })}
                >
                  {index + 1}
                </div>
              </div>
              <div key={index} className={classNames(style.stepName)}>
                {item.component}
                {item.title}
              </div>
            </div>
          );
        })}
        <div className={style.stepperLine} />
      </div>
      <div className={style.wrapper}>
        {data.step === 1 && (
          <Customer
            isOnboarding={isLoading}
            markAsOnboarded={markAsOnboarded}
          />
        )}
        {data.step === 2 && (
          <Offering
            isOnboarding={isLoading}
            markAsOnboarded={markAsOnboarded}
          />
        )}
        {data.step === 3 && (
          <Team isOnboarding={isLoading} markAsOnboarded={markAsOnboarded} />
        )}
      </div>
    </OnboardingContext.Provider>
  );
}

export default Onboarding;
